export const createDynamicCanonicalItems = () => [];
